import { render, staticRenderFns } from "./PaymentReminderModal.vue?vue&type=template&id=7693ddc5&"
import script from "./PaymentReminderModal.vue?vue&type=script&lang=ts&"
export * from "./PaymentReminderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports